var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110 110",
    id: 1148638715,
    className: "svg u_1148638715",
    "data-icon-custom": "true",
    "data-icon-name": "telefono.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-1148638715{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 55,
    fill: "#4396EE"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-1148638715",
    d: "M68.61,18.24H41.7a9.29,9.29,0,0,0-9.29,9.29V81.35a9.29,9.29,0,0,0,9.29,9.29H68.61a9.29,9.29,0,0,0,9.29-9.29V27.53A9.29,9.29,0,0,0,68.61,18.24ZM49,23H61.34v3.38H49Zm6.18,65.63a4.34,4.34,0,1,1,4.34-4.34A4.35,4.35,0,0,1,55.16,88.61Zm17.5-10.54h-35V30.26h35Zm-17.5,3.05a3.15,3.15,0,1,0,3.14,3.15A3.16,3.16,0,0,0,55.16,81.12Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.3d87f3a740ebb898bf3a5f1bbbb37a6b.svg";
export { ForwardRef as ReactComponent };